import { Injectable } from '@angular/core';

@Injectable()
export class HeaderOverrideService {

  private _dataOperacao: string;
  private _exercicio: string;
  private _competencia: string;

  set dataOperacao(value: string) {
    this._dataOperacao = value;
  }

  set exercicio(value: string) {
    if(value) {
      this._exercicio = Number(value).toString();
    } else {
      this._exercicio = value;
    }
  }

  set competencia(value: string) {
    if(value) {
      this._competencia = Number(value).toString();
    } else {
      this._competencia = value;
    }
  }

  get dataOperacao(): string {
    return this._dataOperacao;
  }

  get competencia(): string {
    return this._competencia;
  }

  get exercicio(): string {
    return this._exercicio;
  }

  public clear() {
    this.dataOperacao = null;
    this.exercicio = null;
    this.competencia = null;
  }
}
